export default __webpack_public_path__ + "static/media/qufus_logo_original.6e4754dd.png";